<div class="ck-backdrop" (click)="dismiss.emit()">
  <div class="ck-dialog" role="dialog" aria-modal="true" aria-labelledby="ck-title" (click)="$event.stopPropagation()">

    <header class="ck-head">
      <h2 id="ck-title">Prerequisite check</h2>
      <button type="button" class="ck-x" aria-label="Close" (click)="dismiss.emit()">
        <i class="fa fa-times" aria-hidden="true"></i>
      </button>
    </header>

    <!-- Row template shared by every list -->
    <ng-template #rowTpl let-row>
      <li class="ck-row">
        <i class="fa ck-ic" [ngClass]="[icon(row.result), 'ic-' + row.result]" aria-hidden="true"></i>
        <div class="ck-body">
          <div><strong>{{ row.name }}</strong> <span class="ck-id" *ngIf="row.id">{{ row.id }}</span></div>
          <div>{{ row.detail }}</div>
          <div class="ck-fix" *ngIf="row.fix">Fix: {{ row.fix }}</div>
        </div>
      </li>
    </ng-template>

    <div class="ck-content">

      <!-- Checking, nothing to show yet -->
      <div class="ck-state" *ngIf="state == 'checking' && !result" role="status">
        <span class="ck-spin" aria-hidden="true"></span>
        Checking accounts and servers&hellip; this can take a minute.
      </div>

      <!-- Error -->
      <div class="ck-state ck-err" *ngIf="state != 'checking' && error" role="alert">
        <p>{{ error }}</p>
      </div>

      <ng-container *ngIf="result">
        <!-- Banner -->
        <div class="ck-banner" [ngClass]="bannerClass" [class.dim]="state == 'checking'">
          <i class="fa" [ngClass]="bannerIcon" aria-hidden="true"></i>
          <div>
            <strong>{{ bannerTitle }}</strong>
            <div>{{ summaryText }}</div>
          </div>
        </div>
        <p class="ck-meta">
          <ng-container *ngIf="state == 'checking'"><span class="ck-spin" aria-hidden="true"></span> Checking again&hellip; </ng-container>
          <ng-container *ngIf="state != 'checking'">{{ checkedText }}</ng-container>
        </p>

        <div [class.dim]="state == 'checking'">
          <details class="ck-card" *ngFor="let s of sections; trackBy: trackKey" [open]="s.open">
            <summary>
              <i class="fa fa-chevron-right ck-chev" aria-hidden="true"></i>
              <span class="ck-name">{{ s.title }}<span *ngIf="s.sub"> &middot; {{ s.sub }}</span></span>
              <span class="ck-badge" [ngClass]="s.badgeClass">{{ s.badge }}</span>
            </summary>

            <ul class="ck-list">
              <!-- Schedule section: one list, failures first -->
              <ng-container *ngIf="s.flat">
                <ng-container *ngFor="let row of s.rows; trackBy: trackKey">
                  <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: row }"></ng-container>
                </ng-container>
              </ng-container>

              <!-- Account sections -->
              <ng-container *ngIf="!s.flat">
                <ng-container *ngFor="let row of s.shown; trackBy: trackKey">
                  <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: row }"></ng-container>
                </ng-container>

                <li class="ck-more" *ngIf="s.hidden.length">
                  <button type="button" (click)="toggle(s.key + ':more')" [attr.aria-expanded]="isOpen(s.key + ':more')">
                    <span>{{ hiddenText(s) }}</span>
                    <i class="fa fa-chevron-down" [class.flip]="isOpen(s.key + ':more')" aria-hidden="true"></i>
                  </button>
                </li>
                <ng-container *ngIf="isOpen(s.key + ':more')">
                  <ng-container *ngFor="let row of s.hidden; trackBy: trackKey">
                    <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: row }"></ng-container>
                  </ng-container>
                </ng-container>

                <ng-container *ngFor="let row of s.warns; trackBy: trackKey">
                  <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: row }"></ng-container>
                </ng-container>

                <li class="ck-more ok" *ngIf="s.passedRows.length">
                  <button type="button" (click)="toggle(s.key + ':ok')" [attr.aria-expanded]="isOpen(s.key + ':ok')">
                    <span><i class="fa fa-check-circle ic-pass" aria-hidden="true"></i> {{ s.passedText }}</span>
                    <i class="fa fa-chevron-down" [class.flip]="isOpen(s.key + ':ok')" aria-hidden="true"></i>
                  </button>
                </li>
                <ng-container *ngIf="isOpen(s.key + ':ok')">
                  <ng-container *ngFor="let row of s.passedRows; trackBy: trackKey">
                    <ng-container *ngTemplateOutlet="rowTpl; context: { $implicit: row }"></ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ul>
          </details>
        </div>
      </ng-container>

      <p class="ck-note">
        This checks prerequisites at this moment. It doesn&rsquo;t test disk space, access to package repositories,
        or recovery after a reboot.
      </p>
    </div>

    <footer class="ck-foot">
      <button type="button" class="ck-btn" (click)="dismiss.emit()">Close</button>
      <button type="button" class="ck-btn primary" [disabled]="state == 'checking'" (click)="recheck.emit()">
        <i class="fa" [ngClass]="state == 'checking' ? 'fa-spinner fa-spin' : 'fa-refresh'" aria-hidden="true"></i>
        {{ state == 'checking' ? 'Checking…' : 'Check again' }}
      </button>
    </footer>
  </div>
</div>